import { z } from "zod";

export const UploadStatusSchema = z.enum(["PENDING", "READY"]);

export const WorkflowUploadSchema = z.object({
	id: z.string(),
	fileName: z.string(),
	mimeType: z.string(),
	size: z.number().nullable().optional(),
	tag: z.string().nullable().optional(),
	status: UploadStatusSchema,
	url: z.string(),
	createdAt: z.string().optional(),
	updatedAt: z.string().optional(),
});

export const ListWorkflowUploadsResponseSchema = z.object({
	uploads: z.array(WorkflowUploadSchema),
});

export const PresignUploadRequestSchema = z.object({
	fileName: z.string().min(1),
	mimeType: z.string().min(1),
	tag: z.string().min(1).optional(),
});

export const PresignUploadResponseSchema = z.object({
	uploadId: z.string(),
	objectKey: z.string(),
	uploadUrl: z.string(),
	expiresIn: z.number(),
	url: z.string(),
});

export const CompleteUploadResponseSchema = z.object({
	success: z.boolean(),
	uploadId: z.string(),
	status: UploadStatusSchema,
});

export const DeleteUploadResponseSchema = z.object({
	success: z.boolean(),
});

export const DownloadUrlResponseSchema = z.object({
	downloadUrl: z.string(),
	expiresIn: z.number(),
});

export type UploadStatus = z.infer<typeof UploadStatusSchema>;
export type WorkflowUpload = z.infer<typeof WorkflowUploadSchema>;
export type ListWorkflowUploadsResponse = z.infer<typeof ListWorkflowUploadsResponseSchema>;
export type PresignUploadRequest = z.infer<typeof PresignUploadRequestSchema>;
export type PresignUploadResponse = z.infer<typeof PresignUploadResponseSchema>;
export type CompleteUploadResponse = z.infer<typeof CompleteUploadResponseSchema>;
export type DeleteUploadResponse = z.infer<typeof DeleteUploadResponseSchema>;
export type DownloadUrlResponse = z.infer<typeof DownloadUrlResponseSchema>;
